import { useEffect } from 'react';

import fetchExperiment from 'src/dataLayer/remoteData/babbelAPI/getAbTesterDestination';
import { isFlowAvailable } from 'src/viewLayer/components/Flow/flowHelpers';
import { buildValidFlowPath } from 'src/viewLayer/helpers/pathHelpers';
import type { FlowConfig, RouteConfigRef } from 'src/viewLayer/components/Flow/types';
import type { Navigate } from 'src/types/navigate';

interface UseABTesterParams {
  routeConfigRef: RouteConfigRef;
  flowConfig: FlowConfig | null;
  flowId: string;
  learnLang: string;
  navigate: Navigate
};

export default ({
  routeConfigRef,
  flowConfig,
  flowId,
  learnLang,
  navigate
}: UseABTesterParams): void => {
  useEffect(() => {
    // if the downloaded flowConfig's ID is equal to the one in the url
    // no need to call ab-tester again
    if (flowConfig && flowConfig.id === flowId) return;

    if (routeConfigRef.queryParams?.get('useABTester') === 'false') return;

    const getDestination = async (): Promise<void> => {
      const destination = await fetchExperiment({ target: flowId, learnLang });

      if (isFlowAvailable(destination)) {
        const newFlowPath = buildValidFlowPath({
          ...routeConfigRef,
          learnLang,
          flowId: destination
        });

        if (destination !== flowId) navigate(newFlowPath, { replace: true });
      }
    };
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    getDestination();
  }, [flowId, learnLang, routeConfigRef, flowConfig, navigate]);
};
